module.exports = __webpack_public_path__ + "media/images/favicons/favicon-saturday-32x32-65650c138337dc8b939a95f834d497b9.png";